'use strict';

var _protoclass = require('protoclass');

var _protoclass2 = _interopRequireDefault(_protoclass);

var _mixin2 = require('./_mixin');

var _mixin3 = _interopRequireDefault(_mixin2);

var _events = require('events');

var _messages = require('common/messages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
*/

function BaseModel(properties) {

    // TODO - remove this - use notifier pattern instead (CC)
    _events.EventEmitter.call(this);
    this._disposables = [];
    if (properties) this.setProperties(properties);
    this.initialize();
}

/**
*/

(0, _protoclass2['default'])(BaseModel, _events.EventEmitter.prototype, {

    /**
     */

    idProperty: 'guid',

    /**
    */

    __isWatchableObject: true,

    /**
    */

    initialize: function initialize() {},

    /**
     */

    addDisposable: function addDisposable(disposable) {
        this._disposables.push(disposable);
        return disposable;
    },

    /**
    */

    equals: function equals(model) {
        return model[this.idProperty] === this[this.idProperty];
    },

    /**
    */

    set: function set(key, value) {
        if (this[key] !== value) {
            var oldProps = {};
            var newProps = {};
            oldProps[key] = this[key];
            this[key] = newProps[key] = value;
            this.onPropertiesChange(oldProps, newProps);
        }
    },

    /**
    */

    setProperties: function setProperties(properties) {

        var oldValues = {};
        var hasChange = false;

        for (var key in properties) {
            var newValue = properties[key];
            if (newValue !== this[key]) {
                oldValues[key] = this[key];
                this[key] = properties[key];
                hasChange = true;
            }
        }

        if (hasChange) {
            this.onPropertiesChange(oldValues, properties);
        }
    },

    /**
     * disposes the model
     */

    dispose: function dispose() {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = this._disposables.concat()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var disposeable = _step.value;

                disposable.dispose();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator['return']) {
                    _iterator['return']();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    },

    /**
    */

    onPropertiesChange: function onPropertiesChange(oldProps, newProps) {

        if (newProps.data) {
            this.onDataChange(newProps.data);
        } else {

            // deprecated. This may slow things down tremendously
            this.emit('change');
            if (this.notifier) {
                // this.notifier.notify(ChangeMessage.create(this, { oldProps: oldProps, newProps: newProps }));
            }
        }
    },

    /**
     */

    onDataChange: function onDataChange(data) {
        var props = this.fromData(data);
        this.setProperties(props);
    },

    /**
    */

    fromData: function fromData(data) {
        return data;
    },

    /**
    */

    toData: function toData() {
        var data = {};
        var target = this.data ? this.data : this;
        for (var key in target) {
            if (target.hasOwnProperty(key)) {
                data[key] = this[key];
            }
        }
        return data;
    },

    /**
    */

    toJSON: function toJSON() {
        return this.toData();
    }
});

var oldExtend = BaseModel.extend;

BaseModel.extend = function (properties) {

    var self = this;

    function ChildModel(properties) {

        // DEPRECATED. Simple check here if instantiated context has basic model props
        if (!this || !this.setProperties) {
            console.error('class instance is being created without "new" operator. Use factory class.create() method instead!');
            return new ChildModel(properties);
        }

        self.call(this, properties);
    }

    if (properties && properties.mixins) {
        properties = (0, _mixin3['default'])([properties].concat(properties.mixins));
    }

    oldExtend.call(self, ChildModel, properties);
    ChildModel.extend = self.extend;
    ChildModel.create = self.create;
    return ChildModel;
};

BaseModel.createClass = BaseModel.extend.bind(BaseModel);

// factory method
BaseModel.create = function (properties) {
    return new this(properties);
};

module.exports = BaseModel;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/models/base/model.js
 ** module id = 351
 ** module chunks = 0
 **/